/* global window */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// config
import { config } from '../../config';

// components
import HtmlPart from '../../parts/HtmlPart';
import TextCTA from '../../layout/buttons/TextCTA';
import GhostButton from '../../parts/GhostButton';
import CardTitlePart from '../../parts/CardTitlePart';
import HybrisBasket from '../../parts/HybrisBasket/';
import RefreshSpinner from '../../layout/graphics/RefreshSpinner';
// actions
import { getBasketsforUser } from '../../actions/baskets';

import { gtmCardEvent } from '../../services/gtmService';

class _BasketCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
      refreshing: false
    };
    this.toggleExpand = this.toggleExpand.bind(this);
    this.handleGoToCheckout = this.handleGoToCheckout.bind(this);
    this.handleRefreshBaskets = this.handleRefreshBaskets.bind(this);
  }

  toggleExpand() {
    gtmCardEvent('basket', 'click-show-more', this.state.expanded ? 'hide' : 'expand')();
    this.setState({
      expanded: !this.state.expanded
    });
  }

  handleRefreshBaskets() {
    this.setState({ refreshing: true });
    gtmCardEvent('basket', 'click-refresh')();
    this.props.getBasketsforUser()
    .then(() => this.setState({ refreshing: false }));
  }

  handleGoToCheckout() {
    gtmCardEvent('basket', 'click-checkout')();
    window.location = config.URLS.BASKET_URL;
  }

  render() {
    const { title, basket,
      bodyText = '', expandButtonText, hideButtonText } = this.props;
    const { expanded, refreshing } = this.state;

    const basketHeight = expanded ? '2000px' : '28vh';

    if(!basket || !basket.entries || basket.entries == null) {
      return null;
    }

    return (
      <div>

        <CardTitlePart title={title} />

        <button
          className="c-btn c-btn--text u-spacing-reset c-basket-card__refresh-button"
          disabled={refreshing}
          onClick={this.handleRefreshBaskets}
          aria-label={refreshing ? 'Refreshing basket' : 'Refresh basket'}
        >
          <RefreshSpinner spin={refreshing} />
        </button>

        <div style={{ maxHeight: basketHeight, overflow: 'hidden' }} className="basket-wrap u-padding-small u-pale-grey-bg">

          <HybrisBasket
            {...basket}
          />

          <div className="u-padding-top-small u-flex u-flex-justify-end">
            <GhostButton
              text="checkout"
              onBtnClick={this.handleGoToCheckout}
            />
          </div>

        </div>

        <div className="u-clearfix c-event-feed__card__splitter u-flex-justify-end">
          <TextCTA
            text={expanded ? hideButtonText : expandButtonText}
            position={'right'}
            align={'right'}
            type={expanded ? 'shrink' : 'expand'}
            onBtnClick={this.toggleExpand}
          />
        </div>

        <div className="u-padding-small">
          <HtmlPart htmlString={bodyText} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getBasketsforUser
}, dispatch);

export default connect(null, mapDispatchToProps)(_BasketCard);



// WEBPACK FOOTER //
// ./src/cards/templates/BasketCard.js